import SectionInspection from './SectionInspection';

export default function SteeringInspection() {
  return (
    <SectionInspection
      section="steering"
      title="فحص التوجيه والدفع"
      saveEndpoint="steering"
    />
  );
}
